// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1B4zj","boxTitle":"Qualiphy_boxTitle__26LUB","box":"Qualiphy_box__1pHA7","toggleWrap":"Qualiphy_toggleWrap__32KST"};